import(/* webpackMode: "eager" */ "/app/src/app/(site)/dat-lich/page.tsx");
